import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _242b1c45 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _6c5a0a4c = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _4c911cee = () => interopDefault(import('../../../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _519b5378 = () => interopDefault(import('../../../pages/confirmation.vue' /* webpackChunkName: "pages/confirmation" */))
const _b674c44a = () => interopDefault(import('../../../pages/customer-terms.vue' /* webpackChunkName: "pages/customer-terms" */))
const _0bb2ffa6 = () => interopDefault(import('../../../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _a5930626 = () => interopDefault(import('../../../pages/join.vue' /* webpackChunkName: "pages/join" */))
const _999b0e94 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _6d4d6e9a = () => interopDefault(import('../../../pages/modern-slavery.vue' /* webpackChunkName: "pages/modern-slavery" */))
const _e9c0fd0a = () => interopDefault(import('../../../pages/organisation-sign-up.vue' /* webpackChunkName: "pages/organisation-sign-up" */))
const _ef9f1054 = () => interopDefault(import('../../../pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _5b62a2e7 = () => interopDefault(import('../../../pages/premium/index.vue' /* webpackChunkName: "pages/premium/index" */))
const _5368ca9a = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _a63a1d4a = () => interopDefault(import('../../../pages/review.vue' /* webpackChunkName: "pages/review" */))
const _18e290aa = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _1aa3c3b8 = () => interopDefault(import('../../../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _06d69b9e = () => interopDefault(import('../../../pages/store/index.vue' /* webpackChunkName: "pages/store/index" */))
const _5573f310 = () => interopDefault(import('../../../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _6bd38c22 = () => interopDefault(import('../../../pages/website-terms.vue' /* webpackChunkName: "pages/website-terms" */))
const _bbd49826 = () => interopDefault(import('../../../pages/account/details.vue' /* webpackChunkName: "pages/account/details" */))
const _0de94c8a = () => interopDefault(import('../../../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _421b7d82 = () => interopDefault(import('../../../pages/account/premium.vue' /* webpackChunkName: "pages/account/premium" */))
const _9570b358 = () => interopDefault(import('../../../pages/premium/individual.vue' /* webpackChunkName: "pages/premium/individual" */))
const _3e0462e6 = () => interopDefault(import('../../../pages/verify/new.vue' /* webpackChunkName: "pages/verify/new" */))
const _2cea54c2 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _400677be = () => interopDefault(import('../../../pages/payment/_id.vue' /* webpackChunkName: "pages/payment/_id" */))
const _0827f556 = () => interopDefault(import('../../../pages/premium/_tier.vue' /* webpackChunkName: "pages/premium/_tier" */))
const _243b1f87 = () => interopDefault(import('../../../pages/reset-password/_id.vue' /* webpackChunkName: "pages/reset-password/_id" */))
const _0a43de2e = () => interopDefault(import('../../../pages/store/_slug.vue' /* webpackChunkName: "pages/store/_slug" */))
const _65700cb2 = () => interopDefault(import('../../../pages/verify/_id.vue' /* webpackChunkName: "pages/verify/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _242b1c45,
    name: "404"
  }, {
    path: "/about",
    component: _6c5a0a4c,
    name: "about"
  }, {
    path: "/checkout",
    component: _4c911cee,
    name: "checkout"
  }, {
    path: "/confirmation",
    component: _519b5378,
    name: "confirmation"
  }, {
    path: "/customer-terms",
    component: _b674c44a,
    name: "customer-terms"
  }, {
    path: "/forgot",
    component: _0bb2ffa6,
    name: "forgot"
  }, {
    path: "/join",
    component: _a5930626,
    name: "join"
  }, {
    path: "/login",
    component: _999b0e94,
    name: "login"
  }, {
    path: "/modern-slavery",
    component: _6d4d6e9a,
    name: "modern-slavery"
  }, {
    path: "/organisation-sign-up",
    component: _e9c0fd0a,
    name: "organisation-sign-up"
  }, {
    path: "/payment",
    component: _ef9f1054,
    name: "payment"
  }, {
    path: "/premium",
    component: _5b62a2e7,
    name: "premium"
  }, {
    path: "/privacy-policy",
    component: _5368ca9a,
    name: "privacy-policy"
  }, {
    path: "/review",
    component: _a63a1d4a,
    name: "review"
  }, {
    path: "/search",
    component: _18e290aa,
    name: "search"
  }, {
    path: "/sign-up",
    component: _1aa3c3b8,
    name: "sign-up"
  }, {
    path: "/store",
    component: _06d69b9e,
    name: "store"
  }, {
    path: "/success",
    component: _5573f310,
    name: "success"
  }, {
    path: "/website-terms",
    component: _6bd38c22,
    name: "website-terms"
  }, {
    path: "/account/details",
    component: _bbd49826,
    name: "account-details"
  }, {
    path: "/account/orders",
    component: _0de94c8a,
    name: "account-orders"
  }, {
    path: "/account/premium",
    component: _421b7d82,
    name: "account-premium"
  }, {
    path: "/premium/individual",
    component: _9570b358,
    name: "premium-individual"
  }, {
    path: "/verify/new",
    component: _3e0462e6,
    name: "verify-new"
  }, {
    path: "/",
    component: _2cea54c2,
    name: "index"
  }, {
    path: "/payment/:id",
    component: _400677be,
    name: "payment-id"
  }, {
    path: "/premium/:tier",
    component: _0827f556,
    name: "premium-tier"
  }, {
    path: "/reset-password/:id?",
    component: _243b1f87,
    name: "reset-password-id"
  }, {
    path: "/store/:slug",
    component: _0a43de2e,
    name: "store-slug"
  }, {
    path: "/verify/:id?",
    component: _65700cb2,
    name: "verify-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
